/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';
import useIconDLS from './useIconDLS';

export interface WeightWidgetIconProps {
  color?: string;
  size?: IconSize | number;
}

/*
 * Defines the Design Language System (DLS) Weight Widget Icon component.
 */
export const WeightWidgetIcon = ({size = 30, color = dlsColor('grey3')}: WeightWidgetIconProps) => {
  const {iconSize} = useIconDLS({size});
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 26 29" fill="transparent">
      <circle cx="13" cy="4" r="3.25" stroke={color} strokeWidth="1.5"/>
      <path d="M2.95476 8.75686C3.07887 7.61505 4.04304 6.75 5.19158 6.75H20.8084C21.957 6.75 22.9211 7.61505 23.0452 8.75687L24.8931 25.7569C25.0377 27.0879 23.9951 28.25 22.6562 28.25H3.34376C2.00488 28.25 0.962254 27.0879 1.10693 25.7569L2.95476 8.75686Z" fill="transparent" stroke={color} strokeWidth="1.5"/>
      <path d="M12.4697 24.5303C12.7626 24.8232 13.2374 24.8232 13.5303 24.5303L18.3033 19.7574C18.5962 19.4645 18.5962 18.9896 18.3033 18.6967C18.0104 18.4038 17.5355 18.4038 17.2426 18.6967L13 22.9393L8.75736 18.6967C8.46447 18.4038 7.98959 18.4038 7.6967 18.6967C7.40381 18.9896 7.40381 19.4645 7.6967 19.7574L12.4697 24.5303ZM12.25 6.5L12.25 24L13.75 24L13.75 6.5L12.25 6.5Z" fill={color}/>
    </svg>
  );
};

export default WeightWidgetIcon;
